import { render } from "./GenderSelect.vue?vue&type=template&id=0c929556&scoped=true"
import script from "./GenderSelect.vue?vue&type=script&lang=js"
export * from "./GenderSelect.vue?vue&type=script&lang=js"

import "./GenderSelect.vue?vue&type=style&index=0&id=0c929556&lang=scss&scoped=true"
import "./GenderSelect.vue?vue&type=style&index=1&id=0c929556&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c929556"]])

export default __exports__